/**
 * format.ts — Helpers de formateo de valores para UI.
 *
 * Centralizamos formato de fechas, números, etc. para que cambios de
 * convención (e.g. DD/MM vs MM/DD) sean un solo punto de edición.
 */


/** Sprint 11 S11.3 (motor v8 §2 "Test VAM Mensaje al usuario"):
 *  formato DD/MM/AAAA usado en la nomenclatura obligatoria que el
 *  atleta debe escribir en Strava ("TEST VAM (DD/MM/AAAA)").
 *
 *  El parseo del ISO incluye `T00:00:00` explícito para forzar
 *  interpretación LOCAL del día (evita el bug TZ cazado en S11.2
 *  donde `new Date("2026-05-25")` parseaba como UTC midnight y, en
 *  TZs con offset negativo, devolvía día anterior).
 *
 *  Input: `YYYY-MM-DD` (ISO date sin time, como lo serializa el
 *  backend en `TrainingSession.session_date`).
 *
 *  Output: `DD/MM/AAAA` con zero-padding en día y mes.
 *
 *  Si el input no es parseable, devuelve el string original sin
 *  formatear (fallback no destructivo — no queremos romper la UI
 *  con un error de parseo).
 */
export function formatDateForVamLabel(isoDate: string): string {
  if (!isoDate) return isoDate;
  // Concatenar T00:00:00 fuerza local interpretation.
  const d = new Date(`${isoDate}T00:00:00`);
  if (Number.isNaN(d.getTime())) return isoDate;
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = d.getFullYear();
  return `${day}/${month}/${year}`;
}
